import { ExternalConnectionDto } from "@/lib/integrationTypes/externalConnectionTypes";
import { formatDistanceToNow } from "date-fns";

export const HealthCheckColours = {
    Good: 'bg-green-500',
    Warning: 'bg-yellow-500',
    Critical: 'bg-red-500',
}

export enum HealthCheckStatus {
    Good = 'Good',
    Warning = 'Warning',
    Critical = 'Critical',
}

export interface HealthCheck {
    key: string;
    value: string;
    status: HealthCheckStatus;
}

function findTriggerDiscrepancy(externalConnection: ExternalConnectionDto): HealthCheck {
    let missingTrigger = false;
    let additionalTrigger = false;

    if (externalConnection.webhookAuthCredDto && !externalConnection.integration.webhookSource) {
        additionalTrigger = true;
    }
    if (!externalConnection.webhookAuthCredDto && externalConnection.integration.webhookSource) {
        missingTrigger = true;
    }
    if (externalConnection.smtpUsername && !externalConnection.integration.smtpSource) {
        additionalTrigger = true;
    }
    if (!externalConnection.smtpUsername && externalConnection.integration.smtpSource) {
        missingTrigger = true;
    }

    if (additionalTrigger) {
        return {
            key: 'Integration Status',
            value: 'Integration Disabled',
            status: HealthCheckStatus.Critical
        }
    } else if (missingTrigger) {
        return {
            key: 'Integration Status',
            value: 'Out of Sync',
            status: HealthCheckStatus.Warning
        }
    }
    return {
        key: 'Integration Status',
        value: 'Active',
        status: HealthCheckStatus.Good
    }
}

export function basicConnectionHealthCheck(externalConnection: ExternalConnectionDto): HealthCheck[] {
    return [
        (() => {
            const healthy = ((new Date(externalConnection.lastScanTime).getTime() - new Date().getTime()) / 60 * 1000) < 1.5
            return {
                key: 'Connection Status',
                value: healthy ? 'Online' : 'Stale',
                status: healthy ? HealthCheckStatus.Good : HealthCheckStatus.Warning
            }
        })(),
        findTriggerDiscrepancy(externalConnection),
        {
            key: 'Created',
            value: formatDistanceToNow(new Date(externalConnection.created), { addSuffix: true }),
            status: HealthCheckStatus.Good
        }
    ]
}